import styled from "styled-components";
import { size, display, position } from "styled-system";

const MobileMenuToggle = styled("button")`
  width: 40px;
  padding: 0;
  appearance: none;
  font-family: inherit;
  font-size: 10px;
  line-height: 12px;
  letter-spacing: 0.1em;
  background-color: transparent;
  border: 0;
  text-transform: uppercase;
  cursor: pointer;
  img {
    width: 34px;
    height: auto;
    margin-bottom: 8px;
  }
  ${size};
  ${display};
  ${position};
`;

MobileMenuToggle.defaultProps = {
  display: ["block", null, "none"],
};

export { MobileMenuToggle };
